import TextShadow from './TextShadow';

export default TextShadow;
